var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"avatar",attrs:{"src":_vm.imageUrl,"alt":"Avatar"}})
}
var staticRenderFns = []

export { render, staticRenderFns }